export default __webpack_public_path__ + "static/media/2D_Barcode_Logo_EN_Mobile.6b063019.svg";